import { render, staticRenderFns } from "./TaksitAnaBilgilerForm.vue?vue&type=template&id=3d96d6cc"
import script from "./TaksitAnaBilgilerForm.vue?vue&type=script&lang=ts"
export * from "./TaksitAnaBilgilerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports